import { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Container } from '@material-ui/core';
import Cookies from 'universal-cookie';
import Constants from 'src/utils/Constants';
import ManagerListResults from 'src/components/manager/ManagerListResults';
import ManagerListToolbar from 'src/components/manager/ManagerListToolbar';
import ApiService from 'src/services/ApiService';
import { BackDropContext } from 'src/utils/BackdropContext';

const ManagerList = () => {
  const navigate = useNavigate();
  const cookies = new Cookies();
  const currentUser = cookies.get('umf_user');
  const [managers, setManagers] = useState([]);
  const backdropContext = useContext(BackDropContext);

  useEffect(() => {
    if (currentUser.userType === Constants.CUSTOMER) navigateToDashboard();
    if (
      currentUser.userType === Constants.AGENT &&
      !currentUser.agentPrivileges.managers
    )
      navigateToDashboard();
    if (
      currentUser.userType === Constants.MANAGER &&
      !currentUser.managerPrivileges.managers
    )
      navigateToDashboard();

    loadManagers();
  }, []);

  const loadManagers = async () => {
    backdropContext.setShowBackdrop(true);
    try {
      const { status, data } = await ApiService(currentUser.token).GetManagers(
        {}
      );
      if (status === 200) {
        setManagers(data);
      }
      backdropContext.setShowBackdrop(false);
    } catch (error) {
      backdropContext.setShowBackdrop(false);
      alert(error);
    }
  };

  const navigateToDashboard = () => {
    navigate('/app/dashboard');
  };

  return (
    <>
      <Box
        sx={{
          backgroundColor: 'background.default',
          minHeight: '100%',
          py: 3
        }}
      >
        <Container maxWidth={false}>
          <ManagerListToolbar />
          <Box sx={{ pt: 3 }}>
            <ManagerListResults managers={managers} />
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default ManagerList;
